import "./App.css";
import { Link, Route, Routes } from "react-router-dom";
import { Layout, Typography, Space, ConfigProvider, theme } from "antd";
import {
  Navbar,
  Homepage,
  Cryptocurrencies,
  CryptoDetails,
  News,
  Exchanges,
} from "./components";

import { useState } from "react";

function App() {
  const { defaultAlgorithm, darkAlgorithm } = theme;
  const [isDarkMode, setIsDarkMode] = useState(false);

  const handleClick = () => {
    setIsDarkMode((previousValue) => !previousValue);
  };
  return (
    <>
      <div className="app">
        <div className="navbar">
          <Navbar onChange={handleClick} />
        </div>
        <ConfigProvider
          theme={{
            algorithm: isDarkMode ? darkAlgorithm : defaultAlgorithm,
          }}
        >
          <div className="main">
            <Layout>
              <div className="routes">
                <Routes>
                  <Route exact path="/" element={<Homepage />}></Route>
                  <Route
                    exact
                    path="/exchanges"
                    element={<Exchanges />}
                  ></Route>
                  <Route
                    exact
                    path="/cryptocurrencies"
                    element={<Cryptocurrencies />}
                  ></Route>
                  <Route
                    exact
                    path="/crypto/:coinId"
                    element={<CryptoDetails />}
                  ></Route>
                  <Route exact path="/news" element={<News />}></Route>
                </Routes>
              </div>
            </Layout>

            <div className="footer">
              <Typography.Title
                level={5}
                style={{ color: "white", textAlign: "center" }}
              >
                CryptoHub by Rising Pheonix
                <br />
                <i className="copy">© Copyright 2023, All Rights Reserved</i>
              </Typography.Title>
              <Space>
                <Link to="/">Home</Link>
                <Link to="/exchanges">Exchanges</Link>
                <Link to="/news">News</Link>
              </Space>
            </div>
          </div>
        </ConfigProvider>
      </div>
    </>
  );
}

export default App;
